// https://vuex.vuejs.org/en/actions.html

export default {
  //
}



// WEBPACK FOOTER //
// ./src/store/actions.js